import { CruiseStats } from "components/Algolia/CruiseStats";
import React from "react";
import * as styles from "./Stats.module.scss";

const Stats: React.FC = () => {
  return (
    <div className={styles.stats}>
      <CruiseStats />
    </div>
  );
};

export default Stats;
